<template>
  <div class="swipe">
    <div class="float-win">
      <div class="float" :style="{top:top+'px'}"></div>
      <div v-if="showstate" class="float-t" :style="{right:right+'px'}" @click="drawer=true">
        <span>院校申请试用</span>
      </div>
      <!-- <div v-if="showstate" class="float-b" :style="{left:left+'px'}">国内实习实训信息化管理服务商</div> -->
    </div>
    <el-carousel :interval="4000">
      <el-carousel-item v-for="item in imgs" :key="item">
        <el-image style="height:100%" :src="item" fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>
    <el-drawer :visible.sync="drawer" :with-header="false">
      <div class="drawer-box">
        <h2>院校申请试用</h2>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="学校名称" prop="school_name">
            <el-input v-model="ruleForm.school_name"></el-input>
          </el-form-item>
          <el-form-item label="职  务" prop="posts">
            <el-input v-model="ruleForm.posts"></el-input>
          </el-form-item>
          <el-form-item label="姓  名" prop="contacts">
            <el-input v-model="ruleForm.contacts"></el-input>
          </el-form-item>
          <el-form-item label="手 机 号" prop="contacts_phone">
            <el-input v-model.number="ruleForm.contacts_phone"></el-input>
          </el-form-item>
          <!-- <el-form-item label="验证码" prop="code">
            <el-col :span="12">
              <el-input v-model="ruleForm.code"></el-input>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" style="width:112px;" :disabled="disabled" @click="handleClick">{{codeInfo}}</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="邮  箱" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item> -->
          <el-form-item class="btn">
            <el-button type="primary" @click="submitForm('ruleForm')">申请试用</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="wxgzh">
          <img src="../assets/image/wxgzh.jpg" />
          <p>扫一扫，关注万博云信公众号，了解更多</p>
          <p>客服电话：0571-88026052</p>
        </div>
      </div>
    </el-drawer>

    <!-- <div class="h-box">
      <div class="h-t"></div>
      <div class="h-l">
        <h1 style="margin-top:24px;color:#ece6e9;">Logo And LogOut</h1>
      </div>
      <div class="h-r">
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Swipe',
  data() {
    return {
      proList: [],
      codeInfo: '获取验证码',
      drawer: false,
      top: -310,
      title: '戳这里！申请试用 >>',
      zindex: 0,
      right: -852,
      left: -1052,
      showstate: false,
      imgs: ['https://xixun-dianbo.oss-cn-shanghai.aliyuncs.com/46/1452830/39/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20211028134257.jpg','https://xixun-dianbo.oss-cn-shanghai.aliyuncs.com/46/1452830/39/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20211028134308.jpg'],
      // 'https://vanber-production.oss-cn-shanghai.aliyuncs.com/vanber.cn/vanber_main2.jpeg'
      ruleForm: {
        school_name: '',
        contacts: '',
        contacts_phone: '',
        posts: '',
        email: '',
        // code: '',
      },
      disabled: false,
      rules: {
        school_name: [{ required: true, message: '请输入学校名称', trigger: 'blur' }],
        posts: [{ required: true, message: '请输入职务', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        // code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
        contacts_phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { type: 'number', message: '手机号格式有误' },
        ],
        // email: [
        //   { required: true, message: '请输入邮箱地址', trigger: 'blur' },
        //   { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
        // ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    setTimeout(this.winMove, 1000);
  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    handleClick() {
      if (!this.ruleForm.contacts_phone) {
        this.$refs.ruleForm.validateField('contacts_phone');
        return;
      }
      this.getCode();
      this.disabled = true;
      let second = 59;
      this.codeInfo = `剩余60秒`;
      let timeout = setInterval(() => {
        if (second > 0) {
          this.codeInfo = `剩余${second}秒`;
          second = second - 1;
        } else {
          clearInterval(timeout);
          this.codeInfo = '获取验证码';
          this.disabled = false;
        }
      }, 1000);
    },
    async getCode() {
      let res = await this.$api.instance.getCode({ phone: this.ruleForm.contacts_phone });
      if (res.code == 20000) {
      }
    },
    openDrawf() {
      this.drawer = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.applyTry();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async applyTry() {
      let res = await this.$api.instance.applyTry(this.ruleForm);
      if (res.code == 20000) {
        this.$message.success('提交申请成功，我们将尽快与您联系！');
        this.drawer = false;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      }
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setToken', null);
    },
    winMove() {
      let move = 25;
      let timeout = setInterval(() => {
        if (this.top < 208) {
          if (this.top > 50) {
            move = move - 2;
          }
          this.top = this.top + move;
        } else {
          clearInterval(timeout);
          this.showstate = true;
          this.titleMoveleft();
          this.titleMoveright();
        }
      }, 20);
    },
    titleMoveleft() {
      let move = 24;
      let timeout = setInterval(() => {
        if (this.left < 64) {
          if (this.left > -20) {
            move = move - 4;
          }
          this.left = this.left + move;
        } else {
          clearInterval(timeout);
        }
      }, 16);
    },
    titleMoveright() {
      let move = 25;
      let timeout = setInterval(() => {
        if (this.right < 64) {
          if (this.right > -16) {
            move = move - 4;
          }
          this.right = this.right + move;
        } else {
          clearInterval(timeout);
        }
      }, 20);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-drawer:focus {
  outline: none;
}
/deep/.el-drawer {
  width: 444px !important;
}
/deep/.el-form-item {
  margin-bottom: 24px;
}
.btn {
  /deep/.el-form-item__content {
    margin-left: 16px !important;
  }
}
// /deep/.el-form-item__content {
//   margin-left: 32px !important;
// }
/deep/.el-form-item__label {
  // width: 100px;
  text-align: left;
  // margin-left: 32px;
  font-size: 16px;
}
/deep/.el-drawer__body {
  overflow: auto;
}
.drawer-box {
  height: 100%;
  padding: 48px 40px 0 40px;
  background: #f2f2f3;
  position: relative;
  h2 {
    padding: 24px 0 36px;
    letter-spacing: 4px;
  }
  .wxgzh {
    padding: 32px 0 0 16px;
    img {
      width: 180px;
    }
    p {
      font-size: 13px;
    }
    p + p {
      margin-top: 10px;
    }
  }
}
.swipe {
  // background: #b75d5d;
  width: 100%;
  min-width: 1280px;
  .h-t {
    height: 42px;
    background: #111111;
  }
  .h-b {
    height: 88px;
    background: #ffffff;
  }
  .float-win {
    width: 1200px;
    position: relative;
    margin: 0 auto;
    .float {
      position: absolute;
      height: 180px;
      width: 1072px;
      // background: #111;
      z-index: 666;
      opacity: 0.6;
      top: -310px;
      left: 64px;
    }
    .float-t {
      font-size: 40px;
      color: #6bbfff;
      z-index: 888;
      position: absolute;
      width: 1072px;
      // top: 314px;
      top: 336px;
      // left: 64px;
      right: -1052px;
      span {
        // border-bottom: 4px solid #6bbfff;
        // padding-bottom: 4px;
        color: #1b70b9;
        display: inline-block;
        background: #fff;
        padding: 12px 36px;
        font-size: 20px;
        font-weight: bold;
        border-radius: 28px;
        letter-spacing: 3px;
        box-shadow: 0 0 5px 1px #423c3c;
        background-image: linear-gradient(to right, #bdd5ea, #e8e8e8);
        cursor: pointer;
      }
      span:hover {
        // border-bottom: 4px solid #a7373a;
        // color: #a7373a;
        // box-shadow: 0 0 1px 1px #423c3c;
        background-image: linear-gradient(to right, #e8e8e8, #bdd5ea);
      }
    }
    .float-b {
      position: absolute;
      width: 1072px;
      top: 230px;
      z-index: 888;
      // left: 64px;
      left: -1052px;
      font-size: 56px;
      color: rgb(255, 255, 255);
      letter-spacing: 4px;
      font-weight: bold;
    }
  }
}
.h-box {
  width: 1280px;
  height: inherit;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  .h-l {
    height: inherit;
    width: 50%;
    text-align: left;
  }
  .h-r {
    text-align: right;
    height: inherit;
    width: 50%;
    position: relative;
  }
}
/deep/.el-carousel__container {
  height: 620px;
}
/deep/.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

/deep/.el-carousel__item {
  // transform: unset !important;
  background: #ccc;
}
/deep/.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

/deep/.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.img-style {
  width: 54px;
  height: 54px;
  filter: drop-shadow(0px 0px 1px #ccc);
  border-radius: 29px;
  border: 2px solid #ece6e9;
}
.logOut {
  height: 54px;
  font-size: 14px;
  color: #ece6e9;
  line-height: 54px;
  position: absolute;
  bottom: 24px;
  right: 0;
}
.span-style {
  vertical-align: text-bottom;
  margin-right: 12px;
  cursor: pointer;
}
.span-style:hover {
  color: #ced0dc;
  text-decoration: underline;
}
.el-dropdown {
  color: #ece6e9;
}
</style>
